import { useQuery } from '@tanstack/react-query';
import { QUERY_KEYS } from '@/query/queryKeys';
import { quizService } from '@/query/services/quizService';

export const useGetQuizRedirectInfo = slug => {
  return useQuery({
    enabled: false,
    queryKey: [QUERY_KEYS.quiz.redirect_info, slug],
    queryFn: () =>
      quizService.redirectInfo(slug).then(response => {
        const { status, data } = response;
        if (status === 200) {
          return data;
        }
        const error = new Error('Fetch failed');
        error.response = { status };
        throw error;
      }),
  });
};
